import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  create(entity) {
    const url = `indicador/`
    return new Promise((resolve, reject) => {
      http.post(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  edit(id, entity) {
    const url = `indicador/${id}`
    return new Promise((resolve, reject) => {
      http.put(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOByID(id) {
    const url = `indicador/dto/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOs(ids, filterparams) {
    const params = {
      ids,
      filterparams
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `indicador/dto`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDicionarioIndicadorDTObyID(id) {
    const url = `indicador/dicionario/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntities(ids) {
    const params = {
      ids
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `indicador/`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntityByID(id) {
    const url = `indicador/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findIndicadorFinderDTO(busca, limite) {
    const params = {
      busca,
      limite
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `indicador/finder`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getConsultas(versaobd, tipounidadenegocio, movimentaestoque) {
    const url = `indicador/${versaobd}/${tipounidadenegocio}/${movimentaestoque}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getDtoPresentation() {
    const url = `indicador/dto/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getPresentation() {
    const url = `indicador/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  newEntity() {
    const url = `indicador/new`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  remove(id) {
    const url = `indicador/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}